import { styled } from '@mui/material/styles';
import BaseTextEditor from 'components/TextEditor';

export const TextEditor = styled(BaseTextEditor)(({ theme }) => ({
  marginBottom: theme.spacing(2)
}));
